export interface PrizmTimeLike {
  readonly hours?: number;
  readonly minutes?: number;
  readonly seconds?: number;
  readonly ms?: number;
}
